import React from 'react'
import styles from './giftCardWalletCell.module.scss'
import { Text, TextProps } from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/design_system/components/Button/Button'
import { getCurrencyString } from 'src/helpers/formatAmount'
import ExtraActionsMenu from './ExtraActionsMenu'
import { MinimalCardPreviewFragment } from 'src/graphql/generated/graphql'

type GiftCardWalletCellProps = {
  brand: string
  brandImgUrl: string
  actFrontImgUrl: string
  from: string
  sentDate: string
  expirationDate: string
  currency: string
  amount: string
  card: MinimalCardPreviewFragment
  onRedeem: () => void
}
const LABEL_PROPS = {
  type: 'caption',
  style: { fontSize: '0.775rem', height: '20px' },
} as TextProps
const DATA_PROPS = {
  type: 'caption',
  weight: 'bold',
  style: { paddingLeft: '0.5rem' },
} as TextProps

const GiftCardWalletCell: React.FC<GiftCardWalletCellProps> = props => {
  const {
    brand,
    brandImgUrl,
    from,
    sentDate,
    expirationDate,
    currency,
    amount,
    card,
    onRedeem,
  } = props

  return (
    <div className={styles.rowWrapper}>
      <div className={styles.brandingAndPreviewWrapper}>
        <div className={styles.preview}>
          <div
            className={styles.giftBrandImg}
            style={{
              backgroundImage: `url("${brandImgUrl}")`,
            }}
          />
        </div>
        <div className={styles.brand}>
          <Text type="caption" content={brand} alignment="center" />
        </div>
      </div>
      <div className={styles.detailsWrapper}>
        <div className={styles.deatailItem}>
          <div className={styles.detailTitle}>
            <Text {...LABEL_PROPS} content="From:" />
          </div>
          <div className={styles.detailData}>
            <Text {...DATA_PROPS} content={from} />
          </div>
        </div>
        <div className={`${styles.deatailItem ?? ''} ${styles.on}`}>
          <div className={styles.detailTitle}>
            <Text {...LABEL_PROPS} content="on:" />
          </div>
          <div className={styles.detailData}>
            <Text {...DATA_PROPS} content={sentDate} />
          </div>
        </div>
        <div className={`${styles.deatailItem ?? ''} ${styles.expDate}`}>
          <div className={styles.detailTitle}>
            <Text {...LABEL_PROPS} content="Expiration Date:" />
          </div>
          <div className={styles.detailData}>
            <Text {...DATA_PROPS} content={expirationDate} />
          </div>
        </div>
        <div className={`${styles.deatailItem ?? ''} ${styles.amount}`}>
          <div className={styles.detailTitle}>
            <Text {...LABEL_PROPS} content="Amount:" />
          </div>
          <div className={styles.detailData}>
            <div
              style={{ display: 'flex', height: '100%', alignItems: 'center' }}
            >
              <div
                style={{
                  display: 'flex',
                  height: '100%',
                  justifyContent: 'start',
                }}
              >
                <Text
                  type="footnote"
                  content={`${getCurrencyString(currency)}`}
                  style={{
                    fontWeight: 400,
                    paddingLeft: '0.5rem',
                    paddingRight: '0.25rem',
                    fontSize: '10px',
                  }}
                  inset={{ top: 'x_25' }}
                />
              </div>
              <Text {...DATA_PROPS} content={amount} style={{ padding: 0 }} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.actionWrapper}>
        <Button
          title="View Gift"
          width="100%"
          whiteSpace="nowrap"
          background="#000"
          textColor="#fff"
          onClick={onRedeem}
        />
        <ExtraActionsMenu card={card} from={from} />
      </div>
    </div>
  )
}

export default GiftCardWalletCell
